import React from "react";
import Popup from "reactjs-popup";
import * as image from "../images/promotion-image.png";
import { OutboundLink } from "gatsby-plugin-google-analytics";

const popupImageStyle = {
  width: "100%",
};

class PromotionPopup extends React.Component {
  constructor() {
    super();

    this.state = {
      name: "React",
      open: false,
    };

    this.closePopup = () => {
      this.setState({
        open: false,
      });
    };
    const attemptOpenPopup = () => {
      let proceedToOpenPopup = true;
      if (typeof window !== "undefined") {
        const storage = localStorage.getItem("user");
        let user = storage ? JSON.parse(storage) : null;
        // unix milliseconds
        const now = new Date().getTime();
        if (user) {
          // user may already exist because of the course page interacting with the storage
          if (user.lastOpenedPromotionPopup) {
            // days to milliseconds
            const threeDaysAgo = 259200000;
            if (user.lastOpenedPromotionPopup < now - threeDaysAgo) {
              user.lastOpenedPromotionPopup = now;
            } else {
              // not yet time to show it
              proceedToOpenPopup = false;
            }
          } else {
            user.lastOpenedPromotionPopup = now;
          }
        } else {
          user = {
            lastOpenedPromotionPopup: now,
          };
        }

        localStorage.setItem("user", JSON.stringify(user));
      }
      if (proceedToOpenPopup) {
        this.setState({
          open: true,
        });
      }
    };

    this.handleOnClose = () => {
      this.setState({ open: false });
    };
    // setTimeout(() => {
    //   attemptOpenPopup();
    // }, 20000);
  }

  componentDidMount() {
    this.setState({
      open: false,
    });
  }

  render() {
    return (
      <Popup
        modal={true}
        open={this.state.open}
        onClose={this.handleOnClose}
        arrow={false}
        closeOnDocumentClick={true}
        closeOnEscape={true}
      >
        {() => (
          <div className="row promotion_popup">
            <a id="closeModal" onClick={() => this.closePopup()}>
              &times;
            </a>
            <div className="mailchimp-popup-content col-12">
              <OutboundLink
                target="_blank"
                href="https://store.howtovietnamese.com/?coupon=50BLACKFRIDAY"
              >
                <img style={popupImageStyle} src={image} />
              </OutboundLink>
            </div>
          </div>
        )}
      </Popup>
    );
  }
}

export default PromotionPopup;
